import React from 'react';
import {HomeLine, ChevronRight} from '../Iconpack';
import {Crumb} from './crumb';
import {CrumbText} from './crumbText';
import {Link} from 'react-router-dom';

export interface BreadCrumb {
    label: string | React.ReactNode;
    path?: string;
}

export function generateMediaFileBreadCrumbs({
    folder,
    file,
}: {
    folder?: {name: string};
    file?: {name: string};
}): BreadCrumb[] {
    const breadCrumbs: BreadCrumb[] = [{label: 'Media Library', path: '/media-library'}];
    if (folder) {
        breadCrumbs.push({label: folder.name, path: `/media-library/${folder.name}`});
    }
    if (file) {
        breadCrumbs.push({label: file.name});
    }
    return breadCrumbs;
}

export default function Breadcrumbs({items, children}: {items: BreadCrumb[]; children?: React.ReactNode}) {
    return (
        <div className='flex justify-between bg-[#F2F4F7] px-2 py-[0.938rem] text-gray-700 md:px-[2.063rem]'>
            <nav className='flex'>
                <ol className='inline-flex items-center space-x-3'>
                    <li className='inline-flex hidden items-center space-x-3 md:flex'>
                        <Crumb as={Link} asProps={{to: '/'}}>
                            <HomeLine />
                        </Crumb>
                        <ChevronRight />
                    </li>
                    {items.map((item: any, index: number) => (
                        <li key={index} className='inline-flex items-center space-x-3'>
                            {index > 0 && <ChevronRight />}
                            <Crumb as={Link} asProps={{to: item.path}}>
                                <CrumbText className={index === items.length - 1 ? 'font-[600]' : ''}>
                                    {item['label']}
                                </CrumbText>
                            </Crumb>
                        </li>
                    ))}
                </ol>
            </nav>
            <div className='flex items-center'>{children ?? null}</div>
        </div>
    );
}
